import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function PermissionGuard({ permission, children }) {
  const { user } = useAuth();
  const perms = user?.permissions || {};
  
  if (!perms[permission]) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
}
